// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("D:\\Projekty\\skates\\node_modules\\gatsby-plugin-offline\\app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("D:\\Projekty\\skates\\src\\pages\\404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-global-js": () => import("D:\\Projekty\\skates\\src\\pages\\Global.js" /* webpackChunkName: "component---src-pages-global-js" */),
  "component---src-pages-index-js": () => import("D:\\Projekty\\skates\\src\\pages\\index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

